import { render, staticRenderFns } from "./submitResources.vue?vue&type=template&id=f46a2e50&scoped=true"
import script from "./submitResources.vue?vue&type=script&lang=js"
export * from "./submitResources.vue?vue&type=script&lang=js"
import style0 from "./submitResources.vue?vue&type=style&index=0&id=f46a2e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46a2e50",
  null
  
)

export default component.exports